/*
 * Put-users.ts
 * Description: Includes the declaration
 * of the function for updating a user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Updating a user
 *
 * @return {Object} Promise - when the request has been finished
 * @param {User} data - user data
 */
export function putUser(data) {
    const jwt = localStorage.getItem('jwt');
    if (data.password.length === 0) {
        delete data.password;
        delete data.password_confirmation;
    }
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'users/' + data.id,
            method: 'put',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
